import cx from 'classnames';
import React, {ChangeEvent} from 'react';

interface IProps {
    label?: string;
    value: number;
    onChange: (newValue: number) => void;
    step?: number;
    min?: number;
    max?: number;
    className?: string;
    disabled?: boolean;
    placeholder?: string;
    helpText?: string;
    error?: string;
}

export const NumberInput = ({
                                label,
                                value,
                                step = 1,
                                min,
                                max,
                                onChange,
                                className,
                                disabled,
                                placeholder,
                                helpText,
                                error,
                            }: IProps) => {
    const hasError = error !== undefined;
    const hasErrorMessage = !!error;

    function applyNewValueIfPossible(value: number) {
        if (min !== undefined && value < min) {
            return;
        }

        if (max !== undefined && value > max) {
            return;
        }

        onChange(value);
    }

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const value = +event.target.value;

        if (isNaN(value)) {
            return;
        }

        applyNewValueIfPossible(value);
    }

    return (
        <div className={className}>
            {label && <label
                className={cx(
                    'block text-xs text-left text-london-air-white',
                    disabled ? 'text-gray-500' : 'text-gray-700',
                )}
            >
                {label}
            </label>}
            <div className="relative rounded-md shadow-sm">
                <input
                    type="number"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={cx(
                        'outline-none w-full sm:text-sm sm:leading-5 h-10 p-2 border-2 border-15 text-london-air-white bg-transparent',
                        disabled &&
                        'border-40 text-40 placeholder-60 cursor-not-allowed',
                        hasError &&
                        !disabled &&
                        'border-warning-red text-warning-red placeholder-warning-red focus:border-warning-red focus:ring-warning-red pr-30',
                    )}
                />

                {/* Error icon */}
                {hasError && (
                    <div className="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none">
                        <svg
                            className="h-20 w-20 text-warning-red"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </div>
                )}
            </div>
            {helpText && <p className="mt-8 text-8 text-40">{helpText}</p>}
            {hasErrorMessage && <p className="mt-8 text-8 text-warning-red">{error}</p>}
        </div>
    );
};
